<template>
  <a-modal :visible="visible.batchAddRawList" @ok="ok" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true"
    :forceRender="true" @cancel="toggleVisible('batchAddRawList')" width="900px">
    <span class="title" slot="title">添加原料</span>
    <a-spin :spinning="addLoading">
      <a-space style="padding:0 0 10px">
        <a-input-search :allowClear="true" size="small" v-model="filterData.keyword" @change="inputChange"
          placeholder="原料名称/代码" style="width: 220px" @search="onSearch" />
        <base-list-select style="width:300px" :value="rawType" @change="typeChange" placeholder="选择原料类型"
          category="raw" />
      </a-space>
      <a-table :columns="columns" bordered :scroll="{ x: 870, y: 450 }"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }" :loading="nutLoading" :data-source="list"
        :row-key="record => record.rawId" :pagination="false">
        <template slot="rawName" slot-scope="text,record">
          {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
        </template>
        <template slot="rawTypeName" slot-scope="text, record, index">
          <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
            <template slot="title">
              {{ record.fullTypeName }}
            </template>
            <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
          </a-tooltip>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>
<script>
import BaseListSelect from '../../Nhf/Compound/select/BaseListSelect.vue';
import { formulaMixins } from '../unitls';
export default {
  components: { BaseListSelect },
  props: ['hidden', 'relist'],
  mixins: [formulaMixins],
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading: false,
      filterData: {},
      list: [],
      rawType: [],
      addLoading: false,
      columns: [
        {
          dataIndex: 'rawName',
          title: '原料名称',
          scopedSlots: { customRender: 'rawName' },
        },
        {
          dataIndex: 'rawCode',
          align: 'center',
          title: '代码',
          width: 110
        },
        {
          dataIndex: 'typeName',
          title: '类型',
          width: 200,
          scopedSlots: { customRender: 'rawTypeName' },
        },
      ]
    };
  },

  watch: {
    'visible.batchAddRawList'(val) {
      val ? this.getList() : this.restList();
    }
  },

  methods: {
    inputChange({ target }) {
      this.getList({
        keyword: target.value ? target.value.toUpperCase() : target.value
      });
    },

    async batchUpdate() {
      return this.fetchPost({
        actions: this.batchAddFormulaRawUpdateConfirm,
        loading: 'addLoading',
        data: {
          factoryId: this.factoryId,
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          rawIds: this.selectedRows.map(i => i.rawId).join(),
        }
      });
    },

    async ok() {
      if (this.selectedRows.length) {
        if (this.relist.some(i => this.selectedRows.some(item => item.rawId === i.rawId))) {
          this.$message.warn('已添加的原料，不能重复添加');
        } else {
          const res = await this.batchUpdate();
          this.toggleVisible('batchAddRawList');
          this.$emit('ok', res);
        }
      } else {
        this.$message.warn('选择需要添加的原料');
      }
    },

    getList(arg = {}) {
      return this.fetchGet({
        actions: this.selectReplaceTaskFormulaRaw,
        isList: true,
        name: 'list',
        loading: 'nutLoading',
        data: {
          taskFormulaIds: this.formulaSelectedRows.map(i => i.id).join(),
          size: 2000,
          factoryId: this.factoryId,
          ...this.filterData,
          ...arg,
        }
      });
    },

    restList() {
      this.filterData = {};
      this.rawType = [];
      this.cleanSelect();
    },

    onSearch(keyword) {
      this.getList({
        keyword
      });
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.getList({
        typeId
      });
    },

    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}
</style>
